/**
 * Heights-style cart drawer UI helpers (qty trash icon, empty/filled sync).
 */
(function () {
  const DRAWER_SELECTOR = 'cart-drawer.ncd-cart-drawer';
  const UPDATED_EVENT = 'ncd:cart-drawer:updated';

  function syncQtyIcons(root = document) {
    root.querySelectorAll('.ncd-cart-item__quantity').forEach((qtyWrap) => {
      const input = qtyWrap.querySelector('.quantity__input');
      const minusBtn = qtyWrap.querySelector('button[name="minus"]');
      if (!input || !minusBtn) return;

      const qty = parseInt(input.value, 10) || 0;
      const isTrash = qty <= 1;
      minusBtn.classList.toggle('ncd-cart-item__qty-btn--trash', isTrash);

      const decreaseLabel = minusBtn.dataset.decreaseLabel;
      const removeLabel = minusBtn.dataset.removeLabel;
      if (decreaseLabel && removeLabel) {
        minusBtn.setAttribute('aria-label', isTrash ? removeLabel : decreaseLabel);
      }
    });
  }

  function syncEmptyFilledState() {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    const isEmpty = drawer.classList.contains('is-empty');
    const emptyEl = drawer.querySelector('.ncd-cart-drawer__empty');
    const filledEl = drawer.querySelector('.ncd-cart-drawer__filled');

    if (emptyEl) emptyEl.classList.toggle('hidden', !isEmpty);
    if (filledEl) filledEl.classList.toggle('hidden', isEmpty);
  }

  function handleTrashRemove(event) {
    const minusBtn = event.target.closest('.ncd-cart-item__quantity button[name="minus"]');
    if (!minusBtn) return;

    const qtyWrap = minusBtn.closest('.ncd-cart-item__quantity');
    const input = qtyWrap?.querySelector('.quantity__input');
    const qty = parseInt(input?.value, 10) || 0;

    if (qty > 1) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const lineItem = minusBtn.closest('.ncd-cart-item');
    const cartDrawerItems = minusBtn.closest('cart-drawer-items');
    const line = lineItem?.id?.replace('CartDrawer-Item-', '');

    if (cartDrawerItems && line) {
      cartDrawerItems.enableLoading(line);
    }

    const removeButton = lineItem?.querySelector('cart-remove-button button');
    removeButton?.click();
  }

  function initCartDrawerUI(root = document) {
    syncQtyIcons(root);
    syncEmptyFilledState();
  }

  function dispatchUpdated() {
    document.dispatchEvent(new CustomEvent(UPDATED_EVENT));
  }

  document.addEventListener('click', handleTrashRemove, true);

  document.addEventListener('DOMContentLoaded', () => initCartDrawerUI());
  document.addEventListener(UPDATED_EVENT, () => initCartDrawerUI());

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => initCartDrawerUI());
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.ncd-cart-item__quantity .quantity__input')) {
      syncQtyIcons(event.target.closest('cart-drawer') || document);
    }
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.matches && target.matches(DRAWER_SELECTOR)) {
          syncEmptyFilledState();
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (drawer) {
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  });

  window.NcdCartDrawerUI = {
    init: initCartDrawerUI,
    dispatchUpdated,
  };
})();
